import React from 'react';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Label } from 'reactstrap';

import { IOrderModel, OrderDefinition } from 'models/Order';
import {
  ControlledDatePickerInput,
  ControlledNumberInput,
  ControlledSelect,
  ControlledTextArea,
  ControlledTextInput,
} from 'components/form';
import { ControlledCheckbox } from 'components/form/ControlledCheckbox';

interface Props {
  control: Control<IOrderModel, any>;
  definition: OrderDefinition;
  readOnly: boolean;
}

const OrderGridItem: React.FC<Props> = ({ control, definition, readOnly }) => {
  const { t } = useTranslation('translation');

  const renderItem = () => {
    switch (true) {
      case definition.type === 'text':
        return (
          <ControlledTextInput<IOrderModel>
            control={control}
            fieldName={definition.fieldName}
            readonly={readOnly}
            label={t(definition.label) + (definition.rules?.required ? '*' : '')}
            placeholder={definition.placeholder ? t(definition.placeholder) : ''}
            description={definition.description ? t(definition.description) : ''}
            rules={definition.rules}
          />
        );
      case definition.type === 'date':
        return (
          <ControlledDatePickerInput<IOrderModel>
            control={control}
            fieldName={definition.fieldName}
            readonly={readOnly}
            label={t(definition.label)}
            placeholder={definition.placeholder ? t(definition.placeholder) : ''}
            description={definition.description ? t(definition.description) : ''}
            rules={definition.rules}
          />
        );
      case definition.type === 'number':
        return (
          <ControlledNumberInput<IOrderModel>
            control={control}
            fieldName={definition.fieldName}
            readonly={readOnly}
            label={t(definition.label)}
            placeholder={definition.placeholder ? t(definition.placeholder) : ''}
            description={definition.description ? t(definition.description) : ''}
            rules={definition.rules}
          />
        );
      case definition.type === 'textArea':
        return (
          <ControlledTextArea<IOrderModel>
            control={control}
            fieldName={definition.fieldName}
            readonly={readOnly}
            label={t(definition.label) + (definition.rules?.required ? '*' : '')}
            placeholder={definition.placeholder ? t(definition.placeholder) : ''}
            rules={definition.rules}
          />
        );
      case definition.type === 'checkbox':
        return (
          <ControlledCheckbox<IOrderModel>
            control={control}
            fieldName={definition.fieldName}
            readonly={readOnly}
            label={t(definition.label) + (definition.rules?.required ? '*' : '')}
            rules={definition.rules}
            placeholder={definition.placeholder ? t(definition.placeholder) : ''}
            description={definition.description ? t(definition.description) : ''}
          />
        );
      default:
        return <></>;
    }
  };

  return (
    <Label className={definition.class ? definition.class : 'col-md-6 mt-4'}>{renderItem()}</Label>
  );
};

export default OrderGridItem;
